import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RaciNavigationService } from '../../../../navigation/raci-navigation.service';
import { PropertyCfRequestModel } from '../../models/property-cf-request';
import { UserDashboardService } from '../../services/user-dahsboard.service';

/**
 * Handles the project details component
 */
@Component({
  selector: 'project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.css']
})
export class ProjectDetailsComponent {
  /**
  * Setter for the selected general task property.
  */
  @Input() set selectedGeneralTaskProperty(value: any) {
    if (value) {
      this.propertyData = new PropertyCfRequestModel(value);
      this.getPropertyDetails(this.propertyData?.opportunityPropertyId);
    }
  }

  /**
   * The property data.
   */
  propertyData: any;

  /**
   * The property database data.
   */
  propertyDatabaseData: PropertyCfRequestModel;

  /**
   * The property differences.
   */
  propertyDifferences: any = [];

  /**
   * Constructor
   * @param _userDashboardService UserDashboardService
   * @param translate TranslateService
   */
  constructor(private _userDashboardService: UserDashboardService,
    private _raciNavigationService: RaciNavigationService,
    private translate: TranslateService) {
    //Nothing
  }

  /**
  * On close
  * */
  closeProjectDetails() {
    this._raciNavigationService.onDisplayProjectDetails(false);
  }

  /**
   * Retriving property from DB
   * @param opportunityPropertyId Opportunity property id
   */
  getPropertyDetails(opportunityPropertyId: any) {
    this._userDashboardService.getPropertyDetails(opportunityPropertyId).subscribe(response => {
      if (response) {
        this.propertyDatabaseData = new PropertyCfRequestModel(response, false);
        this.getPropertyDifferences(this.propertyDatabaseData, this.propertyData);
      }
    })
  }

  /**
   * Finding all difference between object in DB and Cf request
   * @param oldValue Value from DB
   * @param newValue Value from Cf request
   * */
  getPropertyDifferences(oldValue: any, newValue: any) {
    if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
      const keyValueDBObject = this.createKeyValueData(oldValue);
      const keyValueCfRequest = this.createKeyValueData(newValue);

      keyValueDBObject.forEach(item => {
        const cfRequest = keyValueCfRequest.find(request => request.key == item.key);

        if (item.value == '' && cfRequest.value == null) {
          item.value = cfRequest.value;
        }

        if (item.value != cfRequest.value) {
          this.propertyDifferences.push(this.createNewDifference(item.key, item.value, cfRequest.value));
        }
      })
    }
  }

  /**
   * Creating new Array of key value pairs
   * */
  createKeyValueData(value: any) {
    const keyValueMap = [];
    const objectKeys = Object.keys(value);

    objectKeys.forEach(key => {
      keyValueMap.push({ "key": this.translate.instant(`raci.userProjectDetails.properties.${key}`), "value": value[key] });
    });

    return keyValueMap;
  }

  /**
   * Creating new difference instance for kendo dropdown*
   * @param label Property label
   * @param oldValue Value from DB
   * @param newValue Value from Cf request
   * */
  createNewDifference(label: string, oldValue: any, newValue: any) {
    return {
      "PropertyLabel": label,
      "PixWF": oldValue,
      "CapForce": newValue
    };
  }
}
